/*
 *   File : index.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Index file for Orders container;
 *   Integrations :  12-08-2022
 *   Version : v1.0
 *   Created :  12-09-2022
*/
/*import packages*/
import { useState, useEffect, useRef } from 'react';
import { Modal } from 'bootstrap';
import moment from 'moment';

/*import components*/
import { DataTable, FundsTab } from '../../components/dataFormating/index';
import { FilterBtn, DownloadBtn, TextBtn, PrimaryBtn } from '../../components/cta/index';
import { OrderDetail, SummaryModal } from '../../components/modal/index';
import { SearchInput, DateRangePicker } from '../../components/input/index';
import SelectBox from '../../components/dropdown/selectBox';
import { Loader } from '../../components/loader';
import { Toast } from '../../components/note';
import { EmptyNote } from '../../components/note';
/*import styles*/
import styles from '../../styles/components/searchInput.module.scss';

import LoaderImg from '../../assets/images/loader/mintd-loader.gif';

/*import assets*/
import View from '../../assets/images/dataFormating/view.png';
import Tooltip from '../../components/badge/tooltip';
import { Toggle } from '../../components/cta/index';


/* import services */
import devconfig from '../../config/config';
import APIPost from '../../services/postApi';
import APIGet from '../../services/getApi';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomMultiSelect from '../../components/dropdown/multi-select';
import PauseScheduledCart from '../../components/modal/pauseScheduledCart';
import DeleteScheduledCart from '../../components/modal/deleteScheduledCart';


const Index = (props) => {

	const wrapperRef = useRef(null);
	const location = useLocation();
	const navigate = useNavigate();

	const [tabIndex, setTabindex] = useState(1);
	const [search, setSearch] = useState("");
	const [searchValue, setSearchValue] = useState("");
	const [filterDown, setFilterDown] = useState(true);
	const [dates, setDates] = useState({
		start: null,
		end: null
	});
	const [cartDates, setCartDates] = useState({
		start: null,
		end: null
	});
	const [more, setMore] = useState(false);
	const [refKey, setRefKay] = useState();
	const [loader, setLoader] = useState(true);
	const [error, setError] = useState(null);
	const [selectedOrderStatus, setSelectedOrderStatus] = useState([]);
	const [selectedPayStatus, setSelectedPayStatus] = useState([]);
	const [selectedGoal, setSelectedGoal] = useState([]);

	const [cartSelectedOrderStatus, setCartSelectedOrderStatus] = useState([]);
	const [cartSelectedPayStatus, setCartSelectedPayStatus] = useState([]);
	const [cartSelectedGoal, setCartSelectedGoal] = useState([]);
	const [orderStatusOptions, setOrderStatusOptions] = useState([]);
	const [paymentStatusOptions, setPaymentStatusOptions] = useState([]);
	const [goalOptions, setGoalOptions] = useState([]);
	const [cartGoalOptions, setCartGoalOptions] = useState([]);
	const [check, setCheck] = useState([])
	const [show, setShow] = useState(null);
	const [orderData, setOrderData] = useState([]);
	const [summaryData, setSummaryData] = useState({});
	const [totalRecords, setTotalRecords] = useState(null);
	/* Total amount for the currently applied filters, across all pages.
	 * Provided by the backend as `total_amount` alongside `total_records` —
	 * not computed from the current page's rows. Shared across tabs like
	 * `totalRecords`, and refreshed by whichever tab's list call last ran. */
	const [totalAmount, setTotalAmount] = useState(null);
	const [details, setDetails] = useState({});
	const [success, setSuccess] = useState(null);
	const [downloadLoader, setDownloadLoader] = useState(false);
	const [type, setType] = useState(null);
	const [pageNum, setPageNum] = useState(1);
	const [perPage, setPerPage] = useState(10);
	const [showSummary, setShowSummary] = useState(false);
	const [scheduledOrders, setScheduledOrders] = useState([]);
	const [selectedCart, setSelectedCart] = useState(null);
	const [openPauseCart, setOpenPauseCart] = useState(false);
	const [openResumeCart, setOpenResumeCart] = useState(false);
	const [openDeleteCart, setOpenDeleteCart] = useState(false);
	const [frequencyOptions, setFrequencyOptions] = useState([]);
	const [selectedFrequency, setSelectedFrequency] = useState(null);
	const [scheduledStatusOptions, setScheduledStatusOptions] = useState([]);
	const [scheduledStatus, setScheduledStatus] = useState([]);
	const [showAnalytics, setShowAnalytics] = useState(false);
	const [analyticLoader, setAnalyticLoader] = useState(false);

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});

		document.addEventListener('mouseup', closeMenu);
		return () => {
			document.removeEventListener('mouseup', closeMenu);
		};

	}, []);

	useEffect(() => {

		const handleNavigation = () => {
			const modalBackdrops = document.querySelectorAll('.modal-backdrop');
			const modals = document.querySelectorAll('.modal.fade.show');

			if (modalBackdrops.length > 0) {
				modalBackdrops.forEach((backdrop) => backdrop.remove());
			}

			if (modals.length > 0) {
				setOpenDeleteCart(false);
				setOpenResumeCart(false);
				setOpenPauseCart(false);
			}

			document.body.removeAttribute('style');
			document.body.removeAttribute('class');
		};


		// Add event listener for the 'popstate' event
		window.addEventListener('popstate', handleNavigation);

		// Clean up the event listener when the component is unmounted
		return () => {
			window.removeEventListener('popstate', handleNavigation);
		};

	}, [tabIndex]);



	useEffect(() => {
		filterData();
		basketfilterData();
		_getFilterData();
	}, [])

	// useEffect(() => {
	// 	if (location.state !== null) {
	// 		filterData(location.state.index);
	// 	}
	// }, [location.state])

	useEffect(() => {
		setPageNum(1);
		setPerPage(10);
		if (location.state !== null) {
			console.log('tabIndex', tabIndex)
			setTabindex(location.state.index);
		} else {
			setTabindex(1);
		}
	}, [location.state]);

	useEffect(() => {
		if (showSummary === true) {
			const modal = new Modal(document.getElementById("summary"));
			modal.show();
		}
	}, [showSummary]);

	useEffect(() => {
		if (openPauseCart === true) {
			const modal = new Modal(document.getElementById("pause-scheduled-cart"));
			modal.show();
		}
	}, [openPauseCart]);

	useEffect(() => {
		if (openDeleteCart === true) {
			const modal = new Modal(document.getElementById("delete-schedule-cart"));
			modal.show();
		}
	}, [openDeleteCart]);

	useEffect(() => {
		if (dates !== null && selectedPayStatus !== null && selectedOrderStatus !== null && type !== null && selectedGoal !== null && tabIndex === 1) {
			getOrderList({
				value: JSON.parse(sessionStorage.getItem("order_search")),
				page: pageNum,
				per_page: perPage,
				show_analytics: showAnalytics
			});
		}
		//eslint-disable-next-line
	}, [dates, selectedPayStatus, selectedOrderStatus, type, selectedGoal, tabIndex, JSON.parse(sessionStorage.getItem("order_search"))]);

	useEffect(() => {
		if (cartDates !== null && cartSelectedPayStatus !== null && cartSelectedOrderStatus !== null && cartSelectedGoal !== null && tabIndex === 2) {
			getCartOrderList({
				value: JSON.parse(sessionStorage.getItem("cart_order_search")),
				page: pageNum,
				per_page: perPage
			});
		}
		//eslint-disable-next-line
	}, [cartDates, cartSelectedPayStatus, cartSelectedOrderStatus, cartSelectedGoal, tabIndex, JSON.parse(sessionStorage.getItem("cart_order_search"))]);

	useEffect(() => {
		if (tabIndex === 3) {
			getScheduledOrderList({
				value: JSON.parse(sessionStorage.getItem("schedule_order_search")),
				page: pageNum,
				per_page: perPage
			});
		}
		//eslint-disable-next-line
	}, [tabIndex, selectedFrequency, scheduledStatus]);

	useEffect(() => {
		setTimeout(() => {
			if (error !== null) {
				setError(null);
			}
		}, 3000);
	}, [error]);

	useEffect(() => {
		if (success !== null) {
			setTimeout(() => {
				setSuccess(null)
			}, 3000)
		}
	}, [success])

	const typeOptions = [
		{ value: null, label: 'All' },
		{ value: 1, label: 'Lumpsum' },
		{ value: 2, label: 'SIP' },
		{ value: 3, label: "Withdraw" },
		{ value: 4, label: "Rebalance-Switch" },
		{ value: 5, label: "STP" },
		{ value: 6, label: "Rebalance-Lumpsum" },
		{ value: 7, label: "Rebalance-Withdrawal" },
	]

	/*---- filter data api --*/
	const filterData = (index) => {
		let payment_options_temp = [];
		let status_options_temp = [];
		let goal_temp = [];

		let url = devconfig.admin + '/order/v2/filter-data';

		APIGet(url).then((response) => {
			if (response.status_code === 200) {
				response.data.payment_status.map((item) => {
					payment_options_temp.push({ value: item.status, label: item.name });
					return true;
				});
				response.data.order_status.map((item) => {
					status_options_temp.push({ value: item.status, label: item.name });
					return true;
				});

				setOrderStatusOptions(status_options_temp);
				setPaymentStatusOptions(payment_options_temp);

				response.data.goal.map((item) => {
					goal_temp.push({ value: item.id, label: item.name, is_ams: item.is_ams });
					return true;
				});
				setGoalOptions(goal_temp);

			}
		});
	}

	// API - get basket data
	const _getFilterData = (id, is_first) => {
		const url = devconfig.admin + "/basket-order/schedule-filter";
		APIGet(url).then((response) => {
			if (response.status_code === 200) {
				const frequency_options = []

				response.data.frequency_filter.map((item) => {
					frequency_options.push({
						label: item.label,
						value: item.id
					})
				})
				setFrequencyOptions(frequency_options);
				setSelectedFrequency(frequency_options[0]);
				const scheduled_status = []
				response.data.status.map((item) => {
					scheduled_status.push({ value: item.id, label: item.label });
					return true;
				});
				setScheduledStatusOptions(scheduled_status)
			}
		})
	}
	/*---- filter data api --*/
	const basketfilterData = (index) => {

		let goal_temp = [];

		let url = devconfig.admin + '/basket-order/v2/basket-filter';

		APIGet(url).then((response) => {
			if (response.status_code === 200) {

				response.data.map((item) => {
					goal_temp.push({ value: item.id, label: item.label, is_ams: item.is_ams });
					return true;
				});
				setCartGoalOptions(goal_temp);

			}
		});
	}

	useEffect(() => {
		if (sessionStorage.getItem("order_status")) {
			setSelectedOrderStatus(JSON.parse(sessionStorage.getItem("order_status")));
			setFilterDown(true);
		} else if (orderStatusOptions.length > 0) {
			setSelectedOrderStatus([]);
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("order_status")]);

	useEffect(() => {
		if (sessionStorage.getItem("cart_order_status")) {
			setCartSelectedOrderStatus(JSON.parse(sessionStorage.getItem("cart_order_status")));
			setFilterDown(true);
		} else if (orderStatusOptions.length > 0) {
			setCartSelectedOrderStatus([]);
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("cart_order_status")]);

	useEffect(() => {
		if (sessionStorage.getItem("payment_status")) {
			setSelectedPayStatus(JSON.parse(sessionStorage.getItem("payment_status")));
			setFilterDown(true);
		} else if (paymentStatusOptions.length > 0) {
			setSelectedPayStatus([]);
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("payment_status")]);

	useEffect(() => {
		if (sessionStorage.getItem("cart_payment_status")) {
			setCartSelectedPayStatus(JSON.parse(sessionStorage.getItem("cart_payment_status")));
			setFilterDown(true);
		} else if (paymentStatusOptions.length > 0) {
			setCartSelectedPayStatus([]);
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("cart_payment_status")]);

	useEffect(() => {
		if (sessionStorage.getItem("goal")) {
			setSelectedGoal(JSON.parse(sessionStorage.getItem("goal")));
			setFilterDown(true);
		} else if (goalOptions.length > 0) {
			setSelectedGoal([]);
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("goal")]);


	useEffect(() => {
		if (sessionStorage.getItem("cart_goal")) {
			setCartSelectedGoal(JSON.parse(sessionStorage.getItem("cart_goal")));
			setFilterDown(true);
		} else if (goalOptions.length > 0) {
			setCartSelectedGoal([]);
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("cart_goal")]);

	// useEffect(() => {
	// 	if (sessionStorage.getItem("page_num")) {
	// 		setPageNum(Number(JSON.parse(sessionStorage.getItem("page_num"))));
	// 	} else {
	// 		setPageNum(1);
	// 	}
	// 	//eslint-disable-next-line
	// }, [sessionStorage.getItem("page_num")]);

	useEffect(() => {
		if (sessionStorage.getItem("type")) {
			setType(JSON.parse(sessionStorage.getItem("type")));
			setFilterDown(true);
		} else {
			setType(typeOptions[0]);
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("type")]);

	useEffect(() => {
		if (sessionStorage.getItem("order_range")) {
			setDates(JSON.parse(sessionStorage.getItem("order_range")));
			setFilterDown(true);
		} else {
			setDates({
				start: null,
				end: null
			});
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("order_range")]);

	useEffect(() => {
		if (sessionStorage.getItem("cart_order_range")) {
			setCartDates(JSON.parse(sessionStorage.getItem("cart_order_range")));
			setFilterDown(true);
		} else {
			setCartDates({
				start: null,
				end: null
			});
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("cart_order_range")]);

	useEffect(() => {
		if (sessionStorage.getItem("scheduled_status")) {
			setScheduledStatus(JSON.parse(sessionStorage.getItem("scheduled_status")));
			setFilterDown(true);
		} else {
			setScheduledStatus([]);
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("scheduled_status")]);

	useEffect(() => {
		if (sessionStorage.getItem("frequency_selected")) {
			setSelectedFrequency(JSON.parse(sessionStorage.getItem("frequency_selected")));
			setFilterDown(true);
		} else {
			setSelectedFrequency(null);
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("frequency_selected")]);

	useEffect(() => {
		if (tabIndex === 1) {
			if (sessionStorage.getItem("order_search")) {
				setSearch(JSON.parse(sessionStorage.getItem("order_search")));
			} else {
				setSearch('');
			}
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("order_search"), tabIndex]);

	useEffect(() => {
		if (tabIndex === 2) {
			if (sessionStorage.getItem("cart_order_search")) {
				setSearch(JSON.parse(sessionStorage.getItem("cart_order_search")));
			} else {
				setSearch('');
			}
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("cart_order_search"), tabIndex]);

	useEffect(() => {
		if (tabIndex === 2) {
			if (sessionStorage.getItem("schedule_order_search")) {
				setSearch(JSON.parse(sessionStorage.getItem("schedule_order_search")));
			} else {
				setSearch('');
			}
		}
		//eslint-disable-next-line
	}, [sessionStorage.getItem("schedule_order_search"), tabIndex]);

	/*---- order table columns -----*/

	const columns = [
		{
			name: 'Order ID',
			selector: (row) => row.order_id ? row.order_id : '--',
			sortable: true,
			left: true,
			minWidth: "110px",
			maxWidth: "110px",
			defaultSortAsc: false,
		},
		{
			name: 'Created on',
			selector: row => row.created,
			sortable: false,
			left: true,
			minWidth: '200px',
			// sortFunction: (a, b) => customDateSort(a, b, 'order_time',),
			cell: row => <div className="col-lg-12" onClick={() => modalOpen(row)}>
				{row.order_time}
			</div>
		},
		{
			name: 'Name',
			selector: row => row.name,
			sortable: true,
			left: true,
			minWidth: '240px',
			cell: row => <>
				{
					row.name ?
						<div className='e-link' onClick={() => {
							navigate(`/user-detail?id=${row.customer_id}`, {
								state: {
									tab: 2
								}
							})
						}}>{row.name}</div>
						:
						"--"
				}
			</>
		},
		{
			name: 'Amount (₹)',
			selector: row => row.amount ? parseFloat(row.amount) : 0,
			// selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
			sortable: true,
			right: true,
			width: '150px',
			cell: row => <div onClick={() => modalOpen(row)}>
				{
					row.amount ?
						row.amount.toLocaleString("en-IN")
						:
						0
				}
			</div>

		},
		{
			name: 'Order status',
			selector: 'order_status',
			sortable: false,
			left: true,
			width: '140px',
			cell: row => <>{row.order_status ?
				<div className="d-inline-flex" onClick={() => modalOpen(row)}>
					<div className="col-lg-10">
						<div className={
							row.order_status === "Partially Success" ? `e-status-badge e-status-badge-partially` :
								row.order_status === "Success" ? `e-status-badge e-status-badge-success` :
									row.order_status === "Failed" ? `e-status-badge e-status-badge-fail` :
										row.order_status === "Processing" ? `e-status-badge e-status-badge-pending` :
											'e-status-badge'
						}>
							{
								row.order_status
							}

						</div>
					</div>
				</div>
				:
				"--"}</>
		},
		{
			name: 'Type',
			selector: row => row.type,
			sortable: true,
			left: true,
			width: "180px",
			cell: (row) => <div className="col-lg-12" onClick={() => modalOpen(row)} >
				{row.type}
			</div>
		},
		{
			name: 'Retry',
			selector: row => row.is_retry ? row.is_retry : false,
			sortable: true,
			left: true,
			minWidth: '100px',
			cell: row => <div onClick={() => modalOpen(row)}>
				{
					row.is_retry ?
						"🔁"
						:
						"-"
				}
			</div>

		},
		{
			name: 'Pending',
			selector: row => row.pending_orders ? row.pending_orders : 0,
			sortable: true,
			left: true,
			width: '110px',
			cell: row => <div onClick={() => modalOpen(row)}>
				{
					row.order_status === "Partially Success" || row.order_status === "Failed" ?
						row.pending_orders ?
							row.pending_orders
							:
							0
						:
						"-"
				}
			</div>

		},
		{
			name: 'Payment status',
			selector: 'payment_status',
			sortable: false,
			left: true,
			minWidth: "160px",

			// cell: row => <div className="">
			//   <Badge type="success" text="success"/>
			// </div>

			cell: (row, key) => <>{row.payment_status ?
				<div className="d-inline-flex" onClick={() => modalOpen(row)}>
					<div className="col-lg-10">
						<div className={
							row.payment_status === "Success" ? `e-status-badge e-status-badge-success` :
								row.payment_status === "Failed" ? `e-status-badge e-status-badge-fail` :
									row.payment_status === "Processing" ? `e-status-badge e-status-badge-pending` :
										row.payment_status === "Submitted" ? `e-status-badge e-status-badge-pending` :
											'e-status-badge'
						}>
							{row.payment_status.toLowerCase()}
						</div>
					</div>
					<div className="col-lg-2">
						<span onMouseEnter={() => setShow(key + 1)} onMouseLeave={() => setShow(null)} className={
							row.payment_status === "Failed" ? `e-icon` :
								row.payment_status === "Processing" ? `e-icon` :
									null
						}>

						</span>
					</div>
					{
						show === (key + 1) ?
							<Tooltip content={row.failure_reason ? row.failure_reason : row.payment_status === "Processing" ? "Transaction pending" : "Transaction failed"} />
							:
							null
					}
				</div>
				:
				"--"}</>
		},
		{
			name: 'Basket/Fund',
			selector: row => row.goal_name,
			sortable: true,
			left: true,
			minWidth: '450px',
			cell: (row) => <div className="col-lg-12" onClick={() => modalOpen(row)} >
				{row.goal_name}
			</div>
		},

		{
			name: 'Payment method',
			sortable: false,
			left: true,
			minWidth: "180px",
			selector: "payment_method",
			cell: row => <div onClick={() => modalOpen(row)}>
				{
					row.payment_method === 1 ?
						"Net banking"
						:
						row.payment_method === 2 ?
							"UPI"
							: row.payment_method === 3 ?
								"Mandate"
								: "None"
				}
			</div>

		},

		{
			name: 'FP Payment ID',
			selector: (row) => row.fp_payment_id ? row.fp_payment_id : '--',
			sortable: false,
			left: true,
			width: "140px",
			defaultSortAsc: false,
			cell: row => <a href={`https://dashboard.fintechprimitives.com/live/resources/payments/${row.fp_payment_id}`} target="_blank">{row.fp_payment_id}</a>
		},
		{
			name: 'FP Order Ids',
			// cell: (row) => row.fp_order_ids ? row.fp_order_ids : '--',
			sortable: false,
			left: true,
			width: "280px",
			defaultSortAsc: false,
			style: {
				cursor: "pointer",
			},
			cell: row =>
				row?.fp_order_ids?.split(",").length > 0 && !row?.fp_order_ids?.split(",").includes("0") ?
					<div className='d-inline'>
						{

							row?.fp_order_ids?.split(",").map((item, index) =>
								<a className='py-0 pe-1' href={`https://dashboard.fintechprimitives.com/live/resources/purchases/${item}`}
									target="_blank" style={{ wordWrap: "break-word" }}>
									{`${item}${index !== row.fp_order_ids.split(",").length - 1 ? "," : ''}`}
								</a>
							)

						}

					</div>
					:
					"-"

		},
		{
			name: '',
			selector: 'actions',
			sortable: false,
			right: true,
			width: "100px !important;",
			cell: (row, key) => <div className="d-flex align-items-end" onClick={() => { setRefKay(key + 1); setMore(!more); }} ref={wrapperRef}>
				<span className="e-more" >
				</span>
				{
					more && (key + 1) === refKey ?
						<div className="e-card-transaction" ref={wrapperRef} onClick={() => modalOpen(row)}>
							<span >
								<img src={View} alt="View details" className="me-2" />View Details
							</span>
						</div>
						:
						null
				}

			</div>
		},
	];

	const SCHEDULE_TABLE_COLS = [
		{
			name: 'Name',
			selector: (row) => row.customer_name ? row.customer_name : '--',
			sortable: true,
			left: true,
			minWidth: "210px",
			maxWidth: "210px",
			defaultSortAsc: false,
		},
		{
			name: 'Type',
			selector: row => row.type,
			sortable: false,
			left: true,
			minWidth: '150px',
		},
		{
			name: 'Frequency',
			selector: row => row.frequency,
			sortable: true,
			left: true,
			width: '150px',
		},
		{
			name: 'Start date',
			selector: row => row.start_date ? row.start_date : 0,
			// selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
			sortable: true,
			left: true,
			minWidth: '130px',
		},
		{
			name: 'Next due',
			selector: row => row.next_due ? row.next_due : 0,
			// selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
			sortable: true,
			left: true,
			minWidth: '130px',
		},
		{
			name: 'End date',
			selector: row => row.end_date ? row.end_date : 0,
			// selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
			sortable: true,
			left: true,
			minWidth: '130px',
		},
		{
			name: 'Repeat',
			selector: row => row.repeat ? row.repeat : '-',
			// selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
			sortable: true,
			left: true,
			minWidth: '180px',
		},
		{
			name: 'Status',
			selector: row => row.status,
			sortable: false,
			left: true,
			width: '140px',
			cell: row => <>{row.status ?
				<div className="d-inline-flex" onClick={() => modalOpen(row)}>
					<div className="col-lg-10">
						<div className={
							row.status === "Active" ? `e-status-badge e-status-badge-success` :
								row.status === "Cancelled" ? `e-status-badge e-status-badge-fail` :
									row.status === "Paused" ? `e-status-badge e-status-badge-pending` :
										'e-status-badge'
						}>
							{
								row.status
							}

						</div>
					</div>
				</div>
				:
				"--"}</>
		},
		{
			name: 'Amount (₹)',
			selector: row => row.amount ? parseFloat(row.amount) : 0,
			// selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
			sortable: true,
			right: true,
			width: '150px',
			cell: row => <div onClick={() => modalOpen(row)}>
				{
					row.amount ?
						row.amount.toLocaleString("en-IN")
						:
						0
				}
			</div>

		},
		{
			name: 'Completed',
			selector: row => row.completed_orders,
			// selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
			sortable: true,
			left: true,
			minWidth: '130px',
		},
		{
			name: 'Pending',
			selector: row => row.pending_orders,
			// selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
			sortable: true,
			left: true,
			minWidth: '130px',
		},


		{
			name: 'Actions',
			selector: 'actions',
			sortable: false,
			right: false,
			minWidth: '200px',
			cell: (row, key) => <div className="d-flex justify-content-between w-100">
				{
					row.is_active === true ?
						<>
							{
								row.pause_requested === false ?
									<div className='e-schedule-pause-btn' onClick={() => {
										setSelectedCart(row.id);
										setOpenPauseCart(true);
									}}>Pause</div>
									:
									null
							}

							<div className='e-schedule-cancel-btn'
								onClick={() => {
									setSelectedCart(row.id);
									setOpenDeleteCart(true);
									setOpenResumeCart(false)
								}}>Cancel</div>
						</>
						: row.is_active === false && row.is_deleted === false ?
							<>
								<div className='e-schedule-resume-btn'
									onClick={() => {
										setSelectedCart(row.id);
										setOpenDeleteCart(true);
										setOpenResumeCart(true);
									}} >Resume</div>
								<div className='e-schedule-cancel-btn'
									onClick={() => {
										setSelectedCart(row.id);
										setOpenDeleteCart(true);
										setOpenResumeCart(false)
									}}>Cancel</div>
							</>
							: null
				}


			</div>
		},
	];

	/*--- func to open order detail modal ---*/
	const modalOpen = (row) => {
		// setDetails(row);
		// var myModal = new Modal(document.getElementById("orderDetail"), {});
		// myModal.show();

		navigate("/order-detail", {
			state: {
				data: row,
			}
		})
	}

	const closeMenu = (event) => {
		if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
			setMore(false);
		}
	}

	const _handlePageChange = (page_num) => {
		setPageNum(page_num);
		if (tabIndex === 1) {
			getOrderList({ value: searchValue, page: page_num, per_page: perPage, show_analytics: showAnalytics })
		} else if (tabIndex === 2) {
			getCartOrderList({ value: searchValue, page: page_num, per_page: perPage, })
		} else {
			getScheduledOrderList({ value: searchValue, page: page_num, per_page: perPage })
		}
	};

	const _handlePerPage = (per_page) => {
		setPerPage(per_page);
		if (tabIndex === 1) {
			getOrderList({ value: searchValue, page: pageNum, per_page: per_page, show_analytics: showAnalytics })
		} else if (tabIndex === 2) {
			getCartOrderList({ value: searchValue, page: pageNum, per_page: per_page })
		} else {
			getScheduledOrderList({ value: searchValue, page: pageNum, per_page: per_page })
		}
	};

	/* --------selecting rows---------*/
	const handleChange = (row) => {
		let selected = []
		for (let i = 0; i < row.selectedRows.length; i++) {
			selected.push(row.selectedRows[i]['order_id']);
		}
		setCheck(selected);
	}

	const handleScheduleChange = (row) => {
		console.log('row', row);
		let selected = []
		for (let i = 0; i < row.selectedRows.length; i++) {
			selected.push(row.selectedRows[i]['id']);
		}
		setCheck(selected);
	}

	const _handleTab = (temp) => {
		if (temp !== tabIndex) {
			setLoader(true);
			navigate("/orders", {
				state: {
					index: temp
				}
			})
			setTabindex(temp);
			setPageNum(1);
			setPerPage(10);
			setSearch("");
		}
	}

	/*--------- order list -----------*/
	const getOrderList = (query) => {
		if (query && query.show_analytics) {
			setAnalyticLoader(true);
		}

		console.log('query.show_analytics', query.show_analytics);
		setCheck([])
		let url = devconfig.admin + '/order/v2/list';
		if (query) {
			setPageNum(query.page);
			setPerPage(query.per_page);
			if (query.value !== "") {
				setSearchValue(query.value);
			}
			setSearch(query.value);
		}
		const goal_payload = selectedGoal
			.filter((filter) => filter.value !== null)
			.map((item) => ({ goal_id: item.value, is_ams: item.is_ams === true }));
		let data = JSON.stringify({
			from_date: dates.start,
			to_date: dates.end,
			type: type.value,
			show_analytics: query ? query.show_analytics : showAnalytics,
			payment_status: selectedPayStatus.filter((filter) => filter.value !== null).map((item) => item.value).length > 0 ? selectedPayStatus.filter((filter) => filter.value !== null).map((item) => item.value) : null,
			order_status: selectedOrderStatus.filter((filter) => filter.value !== null).map((item) => item.value).length > 0 ? selectedOrderStatus.filter((filter) => filter.value !== null).map((item) => item.value) : null,
			query: query ? (query.value) : search,
			page_num: query ? (query.page) : pageNum,
			page_size: query ? (query.per_page) : perPage,
			goal_id: goal_payload.length > 0 ? goal_payload : null,

		});
		APIPost(url, data).then((response) => {
			if (response.status_code === 200) {
				setOrderData(response.data.data ?? response.data);
				setTotalRecords(response.data.total_records)
				setTotalAmount(response.data.total_amount ?? null);
				setSummaryData(response.data);
				setCheck([]);
				setLoader(false);
			} else {
				setLoader(false)
				setOrderData([]);
			}
			setAnalyticLoader(false);
		});
	}

	/*--------- order list -----------*/
	const getCartOrderList = (query) => {
		setCheck([])
		let url = devconfig.admin + '/basket-order/v2/order-list';
		if (query) {
			setPageNum(query.page);
			setPerPage(query.per_page);
			if (query.value !== "") {
				setSearchValue(query.value)
			}
			setSearch(query.value);
		}

		const cart_goal_payload = cartSelectedGoal
			.filter((filter) => filter.value !== null)
			.map((item) => ({ goal_id: item.value, is_ams: item.is_ams === true }));
		let data = JSON.stringify({
			from_date: cartDates.start,
			to_date: cartDates.end,
			payment_status: cartSelectedPayStatus.filter((filter) => filter.value !== null).map((item) => item.value).length > 0 ? cartSelectedPayStatus.filter((filter) => filter.value !== null).map((item) => item.value) : null,
			order_status: cartSelectedOrderStatus.filter((filter) => filter.value !== null).map((item) => item.value).length > 0 ? cartSelectedOrderStatus.filter((filter) => filter.value !== null).map((item) => item.value) : null,
			query: query ? (query.value) : search,
			page_num: query ? (query.page) : pageNum,
			page_size: query ? (query.per_page) : perPage,
			goal_id: cart_goal_payload.length > 0 ? cart_goal_payload : null,

		});
		APIPost(url, data).then((response) => {
			if (response.status_code === 200) {
				setOrderData(response.data.data ?? response.data);
				setTotalRecords(response.data.total_records)
				setTotalAmount(response.data.total_amount ?? null);
				setLoader(false);
			} else {
				setLoader(false)
				setOrderData([]);
			}
		});
	}

	// Scheduled order list
	const getScheduledOrderList = (query) => {
		setCheck([])
		let url = devconfig.admin + '/basket-order/schedule-list';
		if (query) {
			setPageNum(query.page);
			setPerPage(query.per_page);
			if (query.value !== "") {
				setSearchValue(query.value)
			}
			setSearch(query.value);
		}

		let data = JSON.stringify({
			frequency: selectedFrequency?.value,
			status: scheduledStatus.filter((filter) => filter.value !== null).map((item) => item.label).length > 0 ? scheduledStatus.filter((filter) => filter.value !== null).map((item) => item.label) : null,
			query: query ? (query.value) : search,
			page_num: query ? (query.page) : pageNum,
			page_size: 100 //query ? (query.per_page) : perPage

		});
		APIPost(url, data).then((response) => {
			if (response.status_code === 200) {
				setScheduledOrders((response.data.data ?? response.data) || []);
				// setTotalRecords(response.data.total_records)
				setTotalAmount(response.data.total_amount ?? null);

			} else {
				setScheduledOrders([]);
			}
			setLoader(false);
		});
	}


	const _handleShowSummary = (status) => {
		setShowSummary(status);
	}

	/*---- download orders--*/
	const downloadOrderList = (status) => {
		setDownloadLoader(true);
		let url = devconfig.admin + '/order/list-download';
		let data = JSON.stringify({
			user_id: Number(props.id),
			order_ids: check.length === orderData.length ? [] : check,
			is_cart: status
		});
		APIPost(url, data).then((response) => {
			if (response.status_code === 200) {
				if (response.status === true) {
					setDownloadLoader(false);
					// let a = document.createElement("a");
					// a.href = response.data.url;
					// document.body.appendChild(a);
					// a.click();
					// document.body.removeChild(a);
					setSearch("");
					setCheck([]);
					setSuccess("The report has been sent to your email.")
				} else {
					setDownloadLoader(false);
					setError(response.message)
				}
			}
			else {
				setDownloadLoader(false);
				setError(response.message);
			}
		})
	}

	/*---- download orders--*/
	const downloadScheduled = (status) => {
		setDownloadLoader(true);
		let url = devconfig.admin + '/basket-order/schedule-download';
		let data = JSON.stringify({
			user_id: Number(props.id),
			schedule_ids: check.length === orderData.length ? [] : check,
			"frequency": selectedFrequency === null ? selectedFrequency : selectedFrequency?.value,
			"status": scheduledStatus.filter((filter) => filter.value !== null).map((item) => item.label).length > 0 ? scheduledStatus.filter((filter) => filter.value !== null).map((item) => item.label) : null,
			"query": search,
		});

		APIPost(url, data).then((response) => {
			if (response.status_code === 200) {
				if (response.status === true) {
					setDownloadLoader(false);
					let a = document.createElement("a");
					a.href = response.data.url;
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					setSearch("");
					setCheck([]);
					setSuccess("List downloaded successfully")
				} else {
					setDownloadLoader(false);
					setError(response.message)
				}
			}
			else {
				setDownloadLoader(false);
				setError(response.message);
			}
		})
	}


	return (
		<>
			<div className="row">
				<div className="col-lg-12">
					<div className="card e-dashboard-card border-0 py-1">
						{
							loader ?
								<Loader />
								:
								<div className="pt-2">
									<div className='row align-items-center'>
										<div className="col-lg-10">
											<FundsTab data={["Orders", "Cart orders", "Scheduled orders"]}
												index={tabIndex}
												setTab={(temp) => {
													_handleTab(temp)
												}} />
										</div>


										{tabIndex >= 2 && <div className="col-lg-2 col-2">
											<PrimaryBtn name="Create Cart order"
												handleClick={() => {
													navigate("/orders/create-cart-order")
												}} />
										</div>}
									</div>

									<div className="row pt-2">
										{
											tabIndex === 1 &&
											<div className='col-12 mb-2'>
												<Toggle checked={showAnalytics} onChange={(e) => {
													setShowAnalytics(!showAnalytics)
													getOrderList({
														value: "",
														page: pageNum,
														per_page: perPage,
														show_analytics: !showAnalytics
													});
												}} />
												<span className={`${styles.e_toggle_label} pt-3 ps-2`}>Show Analytics</span>
											</div>
										}

										{
											analyticLoader === true ?
												<div className='row'>
													<div className='col-12 text-center pb-4'>
														<img src={LoaderImg} height="50" />
													</div>
												</div>
												:
												<>
													{Object.keys(summaryData).length > 0 && tabIndex === 1 && showAnalytics && <div className='col-12 pb-1 pt-2'>
														<div className='d-flex align-items-center e-horizontal-scroll'>
															<label className='d-block text-start me-2'>
																<p className='mb-2 opacity-0 border-bottom'>.</p>
																<div>Lumpsum</div>
																<div>SIP</div>
																<div>Withdrawal</div>
																<div>Total</div>
															</label>
															<label className='d-block text-center font-weight-600 mx-2 px-2'>
																<p className='mb-2 border-bottom'>Total</p>
																<div>{summaryData.total_data.total_lumpsum_order}</div>
																<div>{summaryData.total_data.total_sip_order}</div>
																<div>{summaryData.total_data.total_redeem_order}</div>
																<div>{summaryData.total_data.final_total}</div>
															</label>

															{
																summaryData.goal_wise_data.map((item) => {
																	return (
																		<label className='d-block text-end mx-2 px-2'>
																			<p className='border-bottom mb-2'>{item.goal_name}</p>
																			<div>{item.basket_lumpsum_amount} ({item.lumpsum_order_count})</div>
																			<div>{item.basket_sip_amount} ({item.sip_order_count})</div>
																			<div>{item.basket_redemption_amount} ({item.redemption_order_count})</div>
																			<div>{item.basket_total_amount} ({item.total_basket_records})</div>
																		</label>
																	)
																})
															}
														</div>
													</div>}
												</>
										}



										{/*-------------- Filters  ---------------*/}
										{
											filterDown ?
												<div className="e-filter-wraper e-sort mt-1">
													{
														tabIndex === 1 ?
															<div className="row align-items-end">
																<div className="col-lg-2 pe-1 col-4 ">
																	<label className="mb-1">Transactions from - till</label>
																	<DateRangePicker
																		onDatesChange={(start, end) => {
																			setPageNum(1);
																			setPerPage(10);
																			setDates({ start: start, end: end });
																			if (start === null && end === null) {
																				sessionStorage.removeItem("order_range");
																			} else {
																				sessionStorage.setItem("order_range", JSON.stringify({ start: start, end: end }));
																			}
																		}}
																		start={dates.start}
																		end={dates.end}
																	/>
																</div>
																<div className="col-lg-2 px-1 col-3 ">
																	<label className="mb-1">Order status</label>
																	<CustomMultiSelect data={orderStatusOptions}
																		selected={selectedOrderStatus}
																		placeHolder="Select order status"
																		select={(list) => {
																			setPageNum(1);
																			setPerPage(10);
																			setSelectedOrderStatus(list);
																			if (list.length === 0) {
																				sessionStorage.removeItem("order_status");
																			} else {
																				sessionStorage.setItem("order_status", JSON.stringify(list));
																			}
																		}}
																	/>
																</div>
																<div className="col-lg-2 px-1 col-3 ">
																	<label className="mb-1">Payment status</label>
																	<CustomMultiSelect data={paymentStatusOptions}
																		selected={selectedPayStatus}
																		placeHolder="Select payment status"
																		select={(list) => {
																			setPageNum(1);
																			setPerPage(10);
																			setSelectedPayStatus(list);
																			if (list.length === 0) {
																				sessionStorage.removeItem("payment_status");
																			} else {
																				sessionStorage.setItem("payment_status", JSON.stringify(list));
																			}
																		}} />
																</div>
																<div className="col-lg-2 px-1 col-3 ">
																	<label className="mb-1">Goal/Basket</label>
																	<CustomMultiSelect
																		selected={selectedGoal}
																		data={goalOptions}
																		placeHolder="Select Goal/Basket"
																		select={(list) => {
																			setPageNum(1);
																			setPerPage(10);
																			setSelectedGoal(list);
																			if (list.length === 0) {
																				sessionStorage.removeItem("goal");
																			} else {
																				sessionStorage.setItem("goal", JSON.stringify(list));
																			}
																		}}
																	/>
																</div>
																<div className="col-lg-2 px-1 col-3">
																	<label className="mb-1">Type</label>
																	<SelectBox
																		value={type}
																		minHeight="39px"
																		options={typeOptions}
																		selectchange={(temp) => {
																			setPageNum(1);
																			setPerPage(10);
																			setType(temp);
																			if (temp.value === null) {
																				sessionStorage.removeItem("type")
																			} else {
																				sessionStorage.setItem("type", JSON.stringify(temp))
																			}
																		}}
																		isSearchable={false}
																	/>
																</div>

																<div className="col-lg-2 ps-1 position-relative mt-3">
																	<div className='d-flex align-items-center bg-white p-1'>
																		<div className='position-relative'>
																			<SearchInput
																				placeholder="Search with MIRA Order ID, Name and Goal"
																				value={search}
																				valueChange={(value) => {
																					setSearch(value);
																					if (value === "") {

																						getOrderList({
																							value: "",
																							page: pageNum,
																							per_page: perPage,
																							show_analytics: showAnalytics
																						});
																						sessionStorage.removeItem("order_search");
																					}
																				}}
																				onSearch={(value) => {
																					getOrderList({
																						value: value,
																						page: 1,
																						per_page: 10,
																						show_analytics: showAnalytics
																					});
																					sessionStorage.setItem("order_search", JSON.stringify(value));

																				}}
																			/>
																			{
																				search && search.length ?
																					<>
																						<span
																							className={`${styles.e_search_submit} `}
																							onClick={() => {
																								getOrderList()
																							}}>
																						</span>
																						<button
																							className={`${styles.e_search_close} pe-3`}
																							onClick={() => {
																								setSearch("");
																								getOrderList({
																									value: "",
																									page: 1,
																									per_page: 10,
																									show_analytics: showAnalytics
																								});
																								sessionStorage.removeItem("order_search");
																							}}>
																						</button>
																					</>
																					:
																					null
																			}

																		</div>
																		<DownloadBtn
																			check={["check"]}
																			loader={downloadLoader}
																			onClick={() => {
																				downloadOrderList(false);
																			}}
																		/>
																	</div>
																</div>

															</div>
															:
															tabIndex === 2 ?
																<div className="row align-items-end">
																	<div className="col-lg-2 pe-1 col-4 ">
																		<label className="mb-1">Transactions from - till</label>
																		<DateRangePicker
																			onDatesChange={(start, end) => {
																				setPageNum(1);
																				setPerPage(10);
																				setCartDates({ start: start, end: end });
																				if (start === null && end === null) {
																					sessionStorage.removeItem("cart_order_range");
																				} else {
																					sessionStorage.setItem("cart_order_range", JSON.stringify({ start: start, end: end }));
																				}
																			}}
																			start={cartDates.start}
																			end={cartDates.end}
																		/>
																	</div>
																	<div className="col-lg-2 px-1 col-3 ">
																		<label className="mb-1">Order status</label>
																		<CustomMultiSelect data={orderStatusOptions}
																			selected={cartSelectedOrderStatus}
																			placeHolder="Select order status"
																			select={(list) => {
																				setPageNum(1);
																				setPerPage(10);
																				setCartSelectedOrderStatus(list);
																				if (list.length === 0) {
																					sessionStorage.removeItem("cart_order_status");
																				} else {
																					sessionStorage.setItem("cart_order_status", JSON.stringify(list));
																				}
																			}}
																		/>
																	</div>
																	<div className="col-lg-2 px-1 col-3 ">
																		<label className="mb-1">Payment status</label>
																		<CustomMultiSelect data={paymentStatusOptions}
																			selected={cartSelectedPayStatus}
																			placeHolder="Select payment status"
																			select={(list) => {
																				setPageNum(1);
																				setPerPage(10);
																				setCartSelectedPayStatus(list);
																				if (list.length === 0) {
																					sessionStorage.removeItem("cart_payment_status");
																				} else {
																					sessionStorage.setItem("cart_payment_status", JSON.stringify(list));
																				}
																			}} />
																	</div>
																	<div className="col-lg-2 px-1 col-3 ">
																		<label className="mb-1">Basket</label>
																		<CustomMultiSelect
																			selected={cartSelectedGoal}
																			data={cartGoalOptions}
																			placeHolder="Select Basket"
																			select={(list) => {
																				setPageNum(1);
																				setPerPage(10);
																				setCartSelectedGoal(list);
																				if (list.length === 0) {
																					sessionStorage.removeItem("cart_goal");
																				} else {
																					sessionStorage.setItem("cart_goal", JSON.stringify(list));
																				}
																			}}
																		/>
																	</div>

																	<div className="col-lg-3 ps-1 position-relative mt-3">
																		<div className='d-flex align-items-center bg-white p-1'>
																			<div className='position-relative'>
																				<SearchInput
																					placeholder="Search with MIRA Order ID, Name and Goal"
																					value={search}
																					valueChange={(value) => {
																						setSearch(value);
																						if (value === "") {
																							getCartOrderList({
																								value: "", page: pageNum, per_page: perPage
																							});
																							sessionStorage.removeItem("cart_order_search");
																						}
																					}}
																					onSearch={(value) => {
																						if (value.length > 0) {
																							getCartOrderList({ value: value, page: 1, per_page: 10 });
																						}
																						sessionStorage.setItem("cart_order_search", JSON.stringify(value));

																					}}
																				/>
																				{
																					search && search.length ?
																						<>
																							<span
																								className={`${styles.e_search_submit} `}
																								onClick={() => {
																									getCartOrderList()
																								}}>
																							</span>
																							<button
																								className={`${styles.e_search_close} pe-3`}
																								onClick={() => {
																									setSearch("");
																									getCartOrderList({
																										value: "",
																										page: 1,
																										per_page: 10
																									});
																									sessionStorage.removeItem("cart_order_search");
																								}}>
																							</button>
																						</>
																						:
																						null
																				}

																			</div>
																			<DownloadBtn
																				check={["check"]}
																				loader={downloadLoader}
																				onClick={() => {
																					downloadOrderList(true);
																				}}
																			/>
																		</div>
																	</div>

																</div>
																:
																<div className="row align-items-end">
																	<div className="col-lg-2 px-1 col-3 ">
																		<label className="mb-1">Status</label>
																		<CustomMultiSelect data={scheduledStatusOptions}
																			selected={scheduledStatus}
																			placeHolder="Select status"
																			select={(list) => {
																				setPageNum(1);
																				setPerPage(10);
																				setScheduledStatus(list);
																				if (list.length === 0) {
																					sessionStorage.removeItem("scheduled_status");
																				} else {
																					sessionStorage.setItem("scheduled_status", JSON.stringify(list));
																				}
																			}} />
																	</div>
																	<div className="col-lg-2 px-1 col-3 ">
																		<label className="mb-1">Frequency</label>
																		<SelectBox options={frequencyOptions}
																			value={selectedFrequency}
																			minHeight="39px"
																			placeholder="Select frequency"
																			isSearchable={false}
																			selectchange={(value) => {
																				setPageNum(1);
																				setPerPage(10);
																				setSelectedFrequency(value);
																				if (value.value !== null) {
																					sessionStorage.setItem("frequency_selected", JSON.stringify(value));
																				}
																			}} />
																	</div>

																	<div className="col-lg-3 ps-1 position-relative mt-3 offset-lg-5">
																		<div className='d-flex align-items-center bg-white p-1'>
																			<div className='position-relative'>
																				<SearchInput
																					placeholder="Search with MIRA Order ID, Name and Goal"
																					value={search}
																					valueChange={(value) => {
																						setSearch(value);
																						if (value === "") {
																							getScheduledOrderList({
																								value: "", page: pageNum, per_page: perPage
																							});
																							sessionStorage.removeItem("schedule_order_search");
																						}
																					}}
																					onSearch={(value) => {
																						if (value.length > 0) {
																							getScheduledOrderList({ value: value, page: 1, per_page: 10 });
																						}
																						sessionStorage.setItem("schedule_order_search", JSON.stringify(value));

																					}}
																				/>
																				{
																					search && search.length ?
																						<>
																							<span
																								className={`${styles.e_search_submit} `}
																								onClick={() => {
																									getScheduledOrderList()
																								}}>
																							</span>
																							<button
																								className={`${styles.e_search_close} pe-3`}
																								onClick={() => {
																									setSearch("");
																									getScheduledOrderList({
																										value: "",
																										page: 1,
																										per_page: 10
																									});
																									sessionStorage.removeItem("schedule_order_search");
																								}}>
																							</button>
																						</>
																						:
																						null
																				}

																			</div>
																			<DownloadBtn
																				check={["check"]}
																				loader={downloadLoader}
																				onClick={() => {
																					downloadScheduled(true);
																				}}
																			/>
																		</div>
																	</div>
																</div>
													}
												</div>
												:
												null
										}

										{/*--------------- Order table -----------*/}
										{
											tabIndex === 1 ?
												(!orderData.length) ?
													<EmptyNote note="There are no orders to show" />
													:
													<div className="col-lg-12 px-0" style={{ position: "relative" }}>
														<DataTable
															pagination={true}
															columns={columns}
															data={orderData}
															perPage={perPage}
															paginationServer={true}
															selectableRows={true}
															paginationDefaultPage={pageNum}
															clearSelectedRows={downloadLoader ? true : false}
															paginationTotalRows={totalRecords}
															onChangeRowsPerPage={_handlePerPage}
															onChangePage={_handlePageChange}
															selectRows={(row) => { handleChange(row) }}
															rowClick={(row) => modalOpen(row)}
														/>
														{/* Total for the currently applied filters, across all pages —
															backend-provided via total_amount, not summed client-side. */}
														<div className="e-table-total" style={{ position: "absolute", left: "8px", bottom: 0, height: "56px", display: "flex", alignItems: "center", fontWeight: 600 }}>
															Total:&nbsp;{totalAmount == null ? '—' : '₹' + totalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
														</div>
													</div>
												: tabIndex === 2 ?
													(!orderData.length) ?
														<EmptyNote note="There are no orders to show" />
														:
														<div className="col-lg-12 px-0" style={{ position: "relative" }}>
															<DataTable
																pagination={true}
																columns={columns}
																data={orderData}
																perPage={perPage}
																paginationServer={true}
																selectableRows={true}
																paginationDefaultPage={pageNum}
																clearSelectedRows={downloadLoader ? true : false}
																paginationTotalRows={totalRecords}
																onChangeRowsPerPage={_handlePerPage}
																onChangePage={_handlePageChange}
																selectRows={(row) => { handleChange(row) }}
																rowClick={(row) => modalOpen(row)}
															/>
															{/* Total for the currently applied filters, across all pages —
																backend-provided via total_amount, not summed client-side. */}
															<div className="e-table-total" style={{ position: "absolute", left: "8px", bottom: 0, height: "56px", display: "flex", alignItems: "center", fontWeight: 600 }}>
																Total:&nbsp;{totalAmount == null ? '—' : '₹' + totalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
															</div>
														</div>
													:
													(!scheduledOrders.length) ?

														<EmptyNote note="There are no orders to show" />
														:
														<div className="col-lg-12 px-0">
															<DataTable
																pagination={false}
																columns={SCHEDULE_TABLE_COLS}
																data={scheduledOrders}
																perPage={perPage}
																paginationServer={true}
																selectableRows={true}
																paginationDefaultPage={pageNum}
																clearSelectedRows={downloadLoader ? true : false}
																paginationTotalRows={totalRecords}
																onChangeRowsPerPage={_handlePerPage}
																onChangePage={_handlePageChange}
																selectRows={(row) => { handleScheduleChange(row) }}
															/>
															{/* No pagination footer on this tab (all rows are loaded at once).
																Total is backend-provided via total_amount, not summed client-side. */}
															<div className="e-table-total mt-2" style={{ fontWeight: 600 }}>
																Total:&nbsp;{totalAmount == null ? '—' : '₹' + totalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
															</div>
														</div>
										}
									</div>
								</div>
						}
					</div>
				</div>
			</div>

			{/*--------- Ordetdetaiil modal component ----------------*/}

			<div ref={wrapperRef}>
				<OrderDetail
					data={details}
					updateList={() => getOrderList("")}
					order_status={details.order_status}
					payment_status={details.payment_status}
				/>
			</div>

			{/* error toast */}
			{
				error !== null ?
					<Toast
						data={error}
						type="eror"
						id="1"
					/>
					:
					null
			}
			{/* Success toast */}
			{
				success !== null ?
					<Toast data={success}
						type="success"
						id="2" />
					:
					null
			}
			{
				openPauseCart === true ?
					<PauseScheduledCart
						cartId={selectedCart}
						updatedFund={getScheduledOrderList}
						handleCloseDateModal={() => {
							setOpenPauseCart(false);
							setSelectedCart(null);
						}} />
					:
					null
			}
			{
				openDeleteCart === true ?
					<DeleteScheduledCart resume={openResumeCart}
						cartId={selectedCart}
						updatedFund={getScheduledOrderList}
						handleCloseDateModal={() => {
							setOpenDeleteCart(false);
							setSelectedCart(null);
						}} />
					:
					null
			}
			{
				showSummary === true && <SummaryModal
					closeModal={() => _handleShowSummary(false)}
					title="Order"
					type={2}
					data={summaryData} />
			}
			<Toast />
		</>
	);
}

export default Index;

